import React, { PropsWithChildren } from "react";
import { UseQueryResult } from "react-query";
import GlobalTransition from "../GlobalTransition";
import EmptyView from "../EmptyView";

// P 是组件 Props, K 是 useQueryHook 返回的数据
type CreateWithQueryHOCOptions<P extends Object, K> = {
  comName: string;
  useQueryHook: () => UseQueryResult<K>;
  Com: React.FunctionComponent<{ refetch: Function; data?: K } & P>;
  errClassName?: string;
  transitionClassName?: string;
};

export function createWithQueryHOC<P extends Object, K>(opts: CreateWithQueryHOCOptions<P, K>) {
  const { comName, useQueryHook, Com, transitionClassName, errClassName } = opts;

  const FC = function (props: PropsWithChildren<P>) {
    const { isLoading, error, refetch, data } = useQueryHook();

    if (isLoading) return <GlobalTransition className={transitionClassName}></GlobalTransition>;

    if (error instanceof Error)
      return (
        <EmptyView status="error" emptyText={error.message} className={errClassName}></EmptyView>
      );

    return (
      <Com {...props} refetch={refetch} data={data}>
        {props.children}
      </Com>
    );
  };

  FC.displayName = `$HOC(${comName})`;

  return FC;
}
